import axios from 'axios';

/**
 * API service for direct communication with the Israeli government data API
 * This service bypasses the backend and communicates directly with data.gov.il
 */
export default class GovernmentDataApi {
  // Resource ID for the company database
  static COMPANY_RESOURCE_ID = 'f004176c-b85f-4542-8901-7b3176f9a054';
  
  /**
   * Search for a company by government ID
   * @param {string} govId - The company government ID to search for
   * @returns {Promise} - Promise with the API response
   */
  static getCompanyByGovId = async (govId) => {
    try {
      const response = await axios.get('https://data.gov.il/api/3/action/datastore_search', {
        params: {
          resource_id: this.COMPANY_RESOURCE_ID,
          q: govId,
          limit: 1
        }
      });

      if (
        response.data &&
        response.data.result &&
        response.data.result.records &&
        response.data.result.records.length > 0
      ) {
        return { 
          success: true, 
          company: response.data.result.records[0] 
        };
      } else {
        return { 
          success: false, 
          errorCode: 4, // Company not found
          errorMessage: 'לא נמצאה חברה עם ח.פ זהה במאגר המידע הממשלתי'
        };
      }
    } catch (error) {
      console.error('Error fetching company by gov ID:', error);
      return {
        success: false,
        errorCode: 3, // Failed to fetch
        errorMessage: 'התקבלה שגיאה בבקשה למאגר המידע הממשלתי'
      };
    }
  };

  /**
   * Search for a company by name
   * @param {string} companyName - The company name to search for
   * @returns {Promise} - Promise with the API response
   */
  static getCompanyByName = async (companyName) => {
    try {
      const response = await axios.get('https://data.gov.il/api/3/action/datastore_search', {
        params: {
          resource_id: this.COMPANY_RESOURCE_ID,
          q: companyName,
          limit: 10 // Return multiple results for name search
        }
      });

      if (
        response.data &&
        response.data.result &&
        response.data.result.records &&
        response.data.result.records.length > 0
      ) {
        return { 
          success: true, 
          companies: response.data.result.records,
          count: response.data.result.records.length
        };
      } else {
        return { 
          success: false, 
          errorCode: 4, // Company not found
          errorMessage: 'לא נמצאו חברות עם שם זהה במאגר המידע הממשלתי'
        };
      }
    } catch (error) {
      console.error('Error fetching company by name:', error);
      return {
        success: false,
        errorCode: 3, // Failed to fetch
        errorMessage: 'התקבלה שגיאה בבקשה למאגר המידע הממשלתי'
      };
    }
  };

  /**
   * Format company address from government data
   * @param {Object} company - The company data from the government API
   * @returns {string} - Formatted address string
   */
  static formatCompanyAddress = (company) => {
    if (!company) return '';
    
    const street = company['שם רחוב'] || '';
    const houseNumber = company['מספר בית'] || '';
    const city = company['שם עיר'] || '';
    const country = company['מדינה'] || 'ישראל';
    
    return `${street} ${houseNumber}, ${city}, ${country}`.trim();
  };

  /**
   * Get company name from government data
   * @param {Object} company - The company data from the government API
   * @returns {string} - Company name
   */
  static getCompanyName = (company) => {
    if (!company) return '';
    return company['שם חברה'] || '';
  };
}
